<template>
<div class="main-body">
  <b-alert
    dismissible
    :show="showDismissibleAlert"
    :variant="alertVariant"
    @dismissed="showDismissibleAlert=false">{{ alertMessage }}</b-alert>
    <form>
      <div class="card">
          <div class="card-body">
              <div class="row">
                  <div class="col-sm-5">
                      <h4 class="card-title mb-0">
                        Marketplace FAQ Management
                      </h4>
                  </div><!--col-->
              </div><!--row-->

              <div class="row mt-4">
                  <div class="col">
                      <div class="form-group row">
                        <label for="courier_id" class="col-sm-2 col-form-label">{{ $t('marketplace.marketplace_name') }}</label>
                        <div class="col-sm-4">
                          <select class="form-control" v-model="marketplaceFaq.marketplace_id">
                            <option value="99" key="all">All Platform</option>
                            <option :value="marketplaceFaq.marketplace_id" disabled>{{ marketplaceFaq.platform }}</option>
                          </select>
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="title" class="col-sm-2 col-form-label">{{ $t('marketplace.faq.title') }}</label>
                        <div class="col-sm-6">
                          <input v-model="marketplaceFaq.title" type="text" name="title" class="form-control">
                        </div>
                      </div>
                       <div class="form-group row">
                        <label for="content" class="col-sm-2 col-form-label">{{ $t('marketplace.faq.content') }}</label>
                        <div class="col-sm-6">
                          <textarea rows="4" v-model.trim="marketplaceFaq.content" type="text" name="content" class="form-control" />
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="status" class="col-sm-2 col-form-label">{{ $t('marketplace.faq.status') }}</label>
                        <div class="col-sm-8">
                          <CSwitch class="mx-1" :checked.sync="status" color="primary" variant="outline" shape="pill"/>
                        </div>
                      </div>
                  </div><!--col-->
              </div><!--row-->

              <div slot="footer">
                <div class="row">
                    <div class="col-7">
                        <div class="float-left"></div>
                    </div><!--col-->
                    <div class="col-5">
                        <div class="float-right">
                            <b-button type="submit" size="sm" variant="primary" @click.stop.prevent="handleSubmit"><i class="fa fa-dot-circle-o"></i> {{ $t('marketplace.faq.update') }}</b-button>
                        </div>
                    </div><!--col-->
                </div><!--row-->
              </div>
          </div><!--card-body-->
      </div><!--card-->
    </form>
   <loading-panel v-if="showLoadingPanel"></loading-panel>
  </div>
</template>
<script>
import loadingPanel from '@/components/LoadingPanel'

export default {
  name: 'FaqEdit',
  components: {
    loadingPanel
  },
  mounted () {
    this.axios.get('/marketplace/faq/' + this.$route.params.id).then(response => {
      this.marketplaceFaq = response.data
      if (this.marketplaceFaq.status === 1) {
        this.status = true
      }
    }).catch(error => {
      console.log(error)
    })
  },
  data () {
    return {
      couriers: [],
      marketplaceFaq: {
        id: '',
        marketplace_id: '',
        title: '',
        content: '',
        status: 0
      },
      showLoadingPanel: false,
      showDismissibleAlert: false,
      alertVariant: '',
      alertMessage: '',
      status: false,
      message: ''
    }
  },
  methods: {
    handleSubmit () {
      if (this.marketplaceFaq.title) {
        // create faq
        this.getMarketplaceStoreStatus()
        this.showLoadingPanel = true
        this.axios.put('/marketplace/faq/' + this.marketplaceFaq.id, this.marketplaceFaq).then(response => {
          this.showLoadingPanel = false
          this.showAlert('success', this.$t('marketplace.faq.success_message'))
          this.message = response.data
        }).catch(error => {
          this.showLoadingPanel = false
          this.showAlert('danger', error.data.message)
        })
      }
    },
    showAlert (alertVariant, message) {
      this.showDismissibleAlert = true
      this.alertVariant = alertVariant
      this.alertMessage = message
    },
    getMarketplaceStoreStatus () {
      if (this.status) {
        this.marketplaceFaq.status = 1
      } else {
        this.marketplaceFaq.status = 0
      }
    }
  }
}
</script>
